import * as addressAS from './address';
import * as employmentAS from './employment';
import * as carModelASV2 from './carModelV2';
import * as makeAS from './make';
import * as modelYearAS from './modelYear';
import * as postalCodeAS from './postalCode';
import * as insuranceCompaniesAS from './insuranceCompanies';
import * as petBreedAS from './petBreed';
import * as postalCodeAS1 from './postalCode1';
import * as leasingCompaniesAS from './leasingCompanies';
import * as addressAS1 from './address1';
import * as dogBreedAS from './dogBreed';

export const getAutoSuggest = variant => {
  switch (variant) {
    case postalCodeAS.type:
      return postalCodeAS;
    case addressAS.type:
      return addressAS;
    case employmentAS.type:
      return employmentAS;
    case carModelASV2.type:
      return carModelASV2;
    case makeAS.type:
      return makeAS;
    case modelYearAS.type:
      return modelYearAS;
    case insuranceCompaniesAS.type:
      return insuranceCompaniesAS;
    case petBreedAS.type:
      return petBreedAS;
    case postalCodeAS1.type:
      return postalCodeAS1;
    case addressAS1.type:
      return addressAS1;
    case leasingCompaniesAS.type:
      return leasingCompaniesAS;
    case dogBreedAS.type:
      return dogBreedAS;
    default:
      console.warn('❌ You need to add your Autosuggest variant to the autoSuggestMap'); // eslint-disable-line
      return {};
  }
};
